import Vue from 'vue';
import { PageModeUtils, PageMode } from '@/main/utils/pageMode';


export const PageModeMixin = Vue.extend({
	computed: {
		/** Return page mode (see file `pageMode.ts`}). */
		pageMode(): PageMode {
			return PageModeUtils.getModeByDefaultView(this.$route.params.mode);
		},
		/** True if {@link this.pageMode} is LIST. */
		isListMode(): boolean {
			return PageModeUtils.isList(this.pageMode);
		},
		/** True if {@link this.pageMode} is SELECT_LIST. */
		isSelectList(): boolean {
			return PageModeUtils.isSelectList(this.pageMode);
		},
		/** True if {@link this.pageMode} is CREATE. */
		isCreateMode(): boolean {
			return PageModeUtils.isCreate(this.pageMode);
		},
		/** True if {@link this.pageMode} is EDIT. */
		isEditMode(): boolean {
			return PageModeUtils.isEdit(this.pageMode);
		},
		/** True if {@link this.pageMode} is VIEW. */
		isViewMode(): boolean {
			return PageModeUtils.isView(this.pageMode);
		},
		/** Returns true if mode is CREATE, VIEW or EDIT. */
		isFormMode(): boolean {
			return this.isCreateMode || this.isEditMode || this.isViewMode;
		},
	},
});
